module.exports = __webpack_public_path__ + "static/media/celebration.fe05ba84.svg";